import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from "antd";
import { useParams } from 'react-router-dom';
import useGetApi from '../../services/useGetApi';
import useDelete from '../../services/useDelete';
import AddnewQuizQuestion from './AddnewQuizQuestion';

const AddQuizQuestion = ({ addQuizQuestion, setAddQuizQuestion, quizSectionId, quizId }) => {
  const { id } = useParams();
  const [addQuestion, setAddQuestion] = useState(true);
  const [mode, setMode] = useState('');
  const [editQuizId, setEditQuizId] = useState(null);

  const [
    quizQuestionIsLoading,
    quizQuestionError,
    quizQuestions,
    getQuizQuestions,
  ] = useGetApi(`sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/questions`, [], true);

  const [isDeleteLoading, deleteError, deleteQuizQuestion] = useDelete();

  // Fetch quiz questions on component mount or when quizSectionId/quizId changes
  useEffect(() => {
    getQuizQuestions(`sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/questions`);
  }, [quizSectionId, quizId, id]);

  // Handle question deletion
  const handleDeleteQuestion = async (questionId) => {
    const response = await deleteQuizQuestion(
      `sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/question/${questionId}`,
      {},
      true
    );
    if (response) {
      getQuizQuestions(`sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/questions`);
    }
  };

  return (
    <>
      {addQuizQuestion && addQuestion && (
        <div className="popup-overlay">
          <div className="addquiz-question-container p-20" >
            <Row gutter={270}>
              <Col>
                <h5>Manage Quiz Sections</h5>
              </Col>
              <Col>
                <button
                  className="close-btn"
                  onClick={() => {
                    setAddQuizQuestion(false);
                  }}
                >
                  <CloseOutlined />
                </button>
              </Col>
            </Row>
            <Row className="popup_horizontal_line"></Row>

            <div className="curriculum_card mt-50">
              <Row justify="space-between" >
                <b>Quiz Name</b>
                <button
                  className="add_quiz-question_btn"
                  type="button"
                  onClick={() => {
                    setAddQuestion(false);
                    setMode('Add');
                  }}
                >
                  Add New question
                </button>
              </Row>

              {Array.isArray(quizQuestions) && quizQuestions.length > 0 && (
                <div className="lesson_div">
                  {quizQuestions.map((quiz) => (
                    <div key={quiz?.id} className="lesson_card">
                      <p>{quiz?.question}</p>
                      <div style={{display:'flex', gap:'10px'}}>
                        <EditOutlined
                          onClick={() => {
                            setMode('Edit');
                            setEditQuizId(quiz?.id);
                            setAddQuestion(false);
                          }}
                        />
                        <CloseOutlined onClick={() => handleDeleteQuestion(quiz?.id)} />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {addQuizQuestion && !addQuestion && (
        <AddnewQuizQuestion 
          addQuizQuestion={addQuizQuestion} 
          setAddQuizQuestion={setAddQuizQuestion}
          quizSectionId={quizSectionId}
          quizId={quizId}
          mode={mode}
          editQuizId={editQuizId}
          setAddQuestion={setAddQuestion}
          getQuizQuestions={getQuizQuestions}
          setEditQuizId={setEditQuizId}
        />
      )}
    </>
  );
};

export default AddQuizQuestion;